import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

function BodyClass() {
  const location = useLocation();
  useLayoutEffect(() => {
    const segments = location.pathname.split("/").filter(Boolean);
    const isLanguageHomepage =
      segments.length === 0 ||
      (segments.length === 1 && /^(en|nl|de)$/i.test(segments[0]));
    const pathClass = isLanguageHomepage
      ? "home"
      : segments.join("-").replace(/[^a-z0-9_-]/gi, "-").toLowerCase();
    const nextClass = `page-${pathClass}`;

    Array.from(document.body.classList)
      .filter((className) => className.startsWith("page-"))
      .forEach((className) => {
        if (className !== nextClass) document.body.classList.remove(className);
      });
    document.body.classList.add(nextClass);

    return () => {
      document.body.classList.remove(nextClass);
    };
  }, [location]);
  return null; 
}

export default BodyClass;
